<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left header-content">
        <strong>{{ $t("INTERVIEW") }}</strong>
      </h5>
    </div>
    <c-table 
      :table-data="questionarryList.list" 
      :fields="tableHeader" :per-page="10" 
      striped 
      hover 
      :total="questionarryList.pageTotal" 
      :update="showStatusChangeModelChange" 
      :edit="editQuestionnarie" 
      :delete="showDeleteModal" 
      :sortTable="sortTable" 
      :isBusy="isBusy" 
      :pagination="pagination"
      :countPerPage="currentPage"></c-table>
    <nav>
      <div class="custom-pagination-font">
        <b-pagination :total-rows="questionarryList.pageTotal" @change="pagination" :per-page="10" v-model="currentPage" :prev-text="$t('FORWARD')" :next-text="$t('NEXT')" />
      </div>
    </nav>
    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}
      </template>
      <p class="my-2 wrapText">
        {{ selecteditemName }} {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteInterviewItem()"
            >{{ $t("DELETE") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer @hidden="close">
<template v-slot:modal-title>
   {{ $t("STATUSCHANGECONFIRMATION") }}
</template>
      <p>{{ $t("CHANGESTATUSCONFIRMATION") }}</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="StatusChange()"
            >{{ $t("SUBMIT") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal size="lg" id="modal-edit"  hide-footer>
<template v-slot:modal-title>
   {{ $t("SURVEYQUESTION") }} > {{dataRange.survey_name}}
</template>
     <span> </span>
      <p>
        <b-row>
          <b-col>
            <b-form-group id="addressField" label-for="input-1">
              <b-row>
                <b-col sm="12" md="5">
                  <span>
                    {{ $t("頻度") }}
                    <span class="mandotry-color">*</span>
                  </span>
                  <b-form-input
                    class="inputField customTextRight"
                    type="number"
                    v-model.trim="$v.dataRange.notify_repeat_period.$model"
                    autocomplete="name"
                    min="1"
                   @keypress="restricZero($event)"
                  ></b-form-input>
                  <show-errors
                    :control="$v.dataRange.notify_repeat_period"
                    :field="$t('MANDATORY')"
                  />
                </b-col>
                <b-col>
                  <span>&nbsp;</span>
                  <b-form-select
                    value-field="id"
                    text-field="name"
                    v-model.trim="$v.dataRange.notify_repeat_unit.$model"
                    :options="[
                      { id: 'year', name: '年' },
                      { id: 'month', name: '月' },
                      { id: 'day', name: '日' }
                    ]"
                  ></b-form-select>

                  <show-errors
                    :control="$v.dataRange.notify_repeat_unit"
                    :field="$t('MANDATORY')"
                  />
                </b-col>
                <b-col sm="12" md="1" class="text-style"
                  >毎</b-col
                >
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="addressField" label-for="input-1">
              <b-row>
                <b-col sm="12" md="8">
                  <span>
                    通知開始
                    <span class="mandotry-color">*</span>
                  </span>
                  <b-form-input
                    class="inputField customTextRight"
                    type="number"
                    @keypress="restricZero($event)"
                    v-model.trim="$v.dataRange.notify_start.$model"
                    autocomplete="name"
                    min="0"
                  ></b-form-input>
                  <show-errors
                    :control="$v.dataRange.notify_start"
                    :field="$t('MANDATORY')"
                  />
                </b-col>
                <b-col sm="12" md="4" class="text-style"
                  >日 前</b-col
                >
              </b-row>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="addressField" label-for="input-1">
              <b-row>
                <b-col sm="12" md="8">
                  <span>
                    有効期間
                    <span class="mandotry-color">*</span>
                  </span>
                  <b-form-input
                    class="inputField customTextRight"
                    type="number"
                    @keypress="restricZero($event)"
                    v-model.trim="$v.dataRange.notify_end.$model"
                    autocomplete="name"
                    min="0"
                  ></b-form-input>
                  <show-errors
                    :control="$v.dataRange.notify_end"
                    :field="$t('MANDATORY')"
                  />
                </b-col>
                <b-col sm="12" md="4" class="text-style"
                  >日 まで</b-col
                >
              </b-row>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="addressField"
              label="通知設定"
              label-for="input-1"
            >
              <b-form-checkbox
                name="check-button"
                v-model.trim="$v.dataRange.notify_status.$model"
                switch
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="saveNotificationChanges"
            >{{ $t("SUBMIT") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            size="sm"
            class="buttons-align-right"
            @click="$bvModal.hide('modal-edit')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import * as _ from "lodash";
  import cTable from "@/components/Table.vue";
  import {
    mapGetters
  } from "vuex";
  import {
    required
  } from "vuelidate/lib/validators";
  import ShowErrors from "@/components/ShowErrors";
  import {
    checkPermisssion,
    pickAs
  } from "@/shared/utils.js";
  
  import {
    QUESTIONNARIE_LIST,
    DELETE_QUESTIONNARIE,
    EDIT_QUESTIONNARIE,
    UPDATE_STATUS_QUESTIONNARIE
  } from "@/store/actions.type";
  
  export default {
    name: "interview-sheet",
    data() {
      return {
        renderComponent: true,
        currentPage: 1,
        tableHeader: [],
        checkPermisssion: checkPermisssion,
        pickAs: pickAs,
        dataRange: {
          notify_repeat_period: "",
          notify_repeat_unit: "day",
          notify_start: "",
          notify_end: "",
          notify_status: ""
        },
        selectedRow: {},
        isLoading: "",
        sortField: "",
        sortDirection: false,
        isBusy: true,
        selecteditemName: ""
      };
    },
    /*validation for the Each fields in From */
    validations: {
      dataRange: {
        notify_repeat_period: {
          required
        },
        notify_repeat_unit: {
          required
        },
        notify_start: {
          required
        },
        notify_end: {
          required
        },
        notify_status: {}
      }
    },
    /*Intilizing the Imported Compomnents */
    components: {
      cTable,
      ShowErrors
    },
    computed: {
      ...mapGetters(["questionarryList"])
    },
    methods: {
      restricZero($event) {
        if ($event.keyCode === 45 || $event.keyCode === 46)
          $event.preventDefault();
      },
      /**
       * Delete function for table Row
       * Input @param {Number} userID selected Row ID
       * Output @param {Boolean}   data.status  Boolean status Api call
       */
      async deleteInterviewItem() {
        this.$bvModal.hide("modal-delete");
  
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
  
        /* Delete questionate action calling.*/
        let data = await this.$store
          .dispatch(DELETE_QUESTIONNARIE, {
            id: this.selectedRow.id
          });
  
        this.isLoading.hide();
        if (_.get(data, "status", false)) {
          this.$toast.success({
            message: _.get(data, "message", '')
          });
          if (this.questionarryList.list.length === 1) {
            this.loadTableData(1);
          } else {
            this.loadTableData(this.currentPage);
          }
        } else {
          this.$toast.error({
            message: _.get(data, "message", '')
          });
        }
  
      },
      /**
       * Edit table row content
       * Input @param {object} row Seleted Row to Edit content of it 
       * Output PopUp the Edit Modal 
       */
      editQuestionnarie(row) {
        this.selectedRow = row;
        this.dataRange = {
          notify_repeat_period: _.get(row, "notify_repeat_period", ""),
          notify_repeat_unit: _.get(row, "notify_repeat_unit", ""),
          notify_start: _.get(row, "notify_start", ""),
          notify_end: _.get(row, "notify_end", ""),
          notify_status: _.get(row, "notify_status", "") == "active" ? true : false,
          survey_name: _.get(row, "survey_category.name", ""),
        };
        this.$bvModal.show("modal-edit");
      },
      /**
       * Show Delete Modal
       * Input @param {object} row Seleted Row to Delete
       * Output PopUp the Delete Modal
       */
      showDeleteModal(row) {
        this.selectedRow = row;
        this.selecteditemName = _.get(
          this.selectedRow,
          "survey_category.name",
          ""
        );
        this.$bvModal.show("modal-delete");
      },
      /**
       * Status function for table Row
       * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
       * Output @param {boolean}   data.status  status of the api call (true or false)
       */
      async StatusChange() {
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
        this.$bvModal.hide("modal-Status");
  
        if (selectedItemId) {
          let status = _.get(this.selectedItemForDelete, "status", "");
          let data = await this.$store
            .dispatch(UPDATE_STATUS_QUESTIONNARIE, {
              id: selectedItemId,
              status: status == "active" ? "inactive" : "active"
            });
          this.isLoading.hide();
          if (_.get(data, "status", false)) {
            this.$toast.success({
              message: _.get(data, "message", '')
            });
            this.isBusy = true;
            this.loadTableData(this.currentPage);
          } else {
            this.$toast.error({
              message: _.get(data, "message", '')
            });
          }
        } else {
          this.$bvModal.hide("modal-Status");
          this.isLoading.hide();
        }
      },
      /**
       * Show Status Change Modal
       * Input @param {object} row Seleted Row to Change status of it
       * Output PopUp the Status Change Modal
       */
      showStatusChangeModelChange(row) {
        this.selectedItemForDelete = row;
        this.$bvModal.show("modal-Status");
      },
      /**
       * Edit funtion for Table row
       * Input @param {object} row Edited Content of the Original Row
       * Output @param {boolean}   data.status  status of the api call (true or false)
       */
      async saveNotificationChanges() {
  
        this.$v.$touch();
        if (!this.$v.dataRange.$invalid) {
          if (this.dataRange.notify_repeat_period < 1) {
            this.$toast.error({
              message: "頻度は0より大きく入力してください。"
            });
            return;
          }
          this.$bvModal.hide("modal-edit");
          this.isLoading = this.$loading.show({
            loader: "dots",
            color: "#007bff"
          });
  
          let payload = this.dataRange;
          payload["id"] = this.selectedRow.id;
          payload.notify_status =
            payload.notify_status == true ? "active" : "inactive";
          let data = await this.$store.dispatch(EDIT_QUESTIONNARIE, payload);
          this.isLoading.hide();
          if (_.get(data, "status", false)) {
            this.loadTableData(this.currentPage);
            this.$toast.success({
              message: _.get(data, "message", "")
            });
          } else {
            this.$toast.error({
              message: _.get(data, "message", "")
            });
          }
        }
      },
      /**
       * Sort function on  table
       * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
       * Output @param {List}   response.list  Filtered List
       */
      sortTable(field, direction) {
        this.isBusy = true;
        this.sortField = field;
        this.sortDirection = direction;
        this.loadTableData(this.currentPage);
      },
      /* Pagintaion */
      pagination(page) {
        this.loadTableData(page);
      },
      /* Pagintaion */
      loadTableData(page) {
        this.currentPage = page;
        this.isBusy = true;
        this.$store
          .dispatch(QUESTIONNARIE_LIST, {
            page: page,
            field: this.sortField,
            sort: this.direction
          })
          .then(data => {
            this.isBusy = false;
          });
      },
      /*Compomonet Rerendering */
      close() {
        this.renderComponent = false;
  
        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
      }
    },
    created() {
      this.$store
        .dispatch(QUESTIONNARIE_LIST, {
          field: "id",
          sort: "desc"
        })
        .then(data => {
          this.isBusy = false;
        });
      this.tableHeader = [{
          key: "id",
          label: this.$t("ID"),
          sortable: true,
          class: "text-left"
        },
        {
          key: "survey_category.name",
          label: "ヘルスチェック票通知設定",
          sortable: true,
          class: "text-left"
        },
        {
          key: "frequency_notify",
          label: "頻度",
          sortable: false,
          class: "text-left"
        },
        {
          key: "advance_notice",
          label: "通知開始",
          sortable: false,
          class: "text-left"
        },
        {
          key: "advance_notice_1",
          class: "text-left",
          label: "有効期間",
          sortable: false
        },
        {
          key: "interViewNotificationStatus",
          label: this.$t("INTERVIEWSTATUS"),
          sortable: false
        }
      ];
      if (checkPermisssion("QUESTIONNAIRE", "QUESTIONNAIRE_LIST")) {
        // allowing users to do actions on table if they have Permission
        this.tableHeader.push({
          key: "status",
          label: this.$t("STATUS"),
          sortable: false
        });
        this.tableHeader.push({
          key: "actions",
          label: this.$t("ACTION"),
          sortable: false
        });
      } else {
        //Disabled the actions on table if they dont have permission
        this.tableHeader.push({
          key: "status_disable",
          label: this.$t("STATUS"),
          sortable: false
        });
      }
    }
  };
</script>

<style scoped>
  .header-content {
    margin-top: 14px;
    margin-bottom: 14px
  }
  .text-style{
    margin-top: 29px;padding-left: 0;
  }
</style>